import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';

const Header = () => {
  return (
    <AppBar position="static" className="bg-primary-main">
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/"
          sx={{
            textDecoration: 'none',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
          }}
        >
          <Lightbulb sx={{ mr: 1 }} />
          每日冷知識
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button color="inherit" component={Link} to="/">
            首頁
          </Button>

          <Button color="inherit" component={Link} to="/submit">
            投稿
          </Button>

          <Button color="inherit" component={Link} to="/auth">
            登入
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
